module.exports = __webpack_public_path__ + "media/images/ig_mobile-f61df012446e0e2327e382005d8b7fb3.svg";